import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import Section from "@/components/layout/Section";
import Container from "@/components/layout/Container";

const faqs = [
  {
    q: "How does Zenia calculate these revenue estimates",
    a: "Estimates use comparable listings, local demand signals, historical pricing data and seasonal patterns. The calculator provides directional insight rather than a guarantee.",
  },
  {
    q: "Are these numbers guaranteed",
    a: "No. These figures are indicative only. Actual performance depends on market conditions, pricing strategy, property quality and operational execution.",
  },
  {
    q: "Why do you need my property location",
    a: "Location drives demand, pricing potential and occupancy patterns. Accurate location data allows comparison with relevant nearby listings.",
  },
  {
    q: "What happens after requesting the detailed report",
    a: "Our team reviews the estimate, validates the inputs manually and prepares a deeper performance outlook before sharing next steps.",
  },
  {
    q: "Can Zenia improve performance beyond this estimate",
    a: "In many cases yes. Pricing optimisation, listing quality, guest experience and operational systems can improve outcomes over time.",
  },
  {
    q: "Which markets does this calculator support",
    a: "The calculator focuses on active short term rental markets across the United States and Canada with strong demand patterns.",
  },
];

export default function FaqTrustSection() {

  const [openIndex, setOpenIndex] = useState(0);

  return (

    <Section background="bg-brand-secondary" padding="md">

      <Container>

        <div className="grid gap-14 lg:grid-cols-2 items-center">

          {/* LEFT COPY */}

          <div className="max-w-content">

            <span className="text-small font-semibold uppercase tracking-wide text-white/70">
              Calculator FAQ
            </span>

            <h3
              className="
              mt-5
              text-display
              font-extrabold
              leading-tight
              text-white
              max-w-[20ch]
              "
            >
              Understanding this estimate
            </h3>

            <p className="mt-6 text-body leading-relaxed text-white/80 max-w-reading">
              Transparency matters. These answers explain how the calculator
              works, the assumptions used and how to interpret the results.
            </p>

            <a
              href="/contact"
              className="
              mt-8
              inline-flex
              items-center
              gap-2
              text-body
              font-semibold
              text-white
              hover:opacity-80
              transition
              "
            >
              Talk to our team
              <span className="text-title">↗</span>
            </a>

          </div>


          {/* RIGHT ACCORDION */}

          <div className="rounded-xl bg-bg-surface p-6 md:p-8 shadow-card">

            <ul className="divide-y border-soft">

              {faqs.map((item, i) => {

                const open = i === openIndex;

                return (

                  <li key={i}>

                    <button
                      onClick={() => setOpenIndex(open ? -1 : i)}
                      className="flex w-full items-center justify-between gap-6 py-5 text-left"
                    >

                      <span className="text-body font-semibold text-text-primary leading-snug">
                        {item.q}
                      </span>

                      <span className="text-title font-medium text-text-muted">
                        {open ? "−" : "+"}
                      </span>

                    </button>

                    <AnimatePresence initial={false}>

                      {open && (

                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.35, ease: "easeOut" }}
                        >

                          <p className="pb-5 pr-8 text-body leading-relaxed text-text-muted">
                            {item.a}
                          </p>

                        </motion.div>

                      )}

                    </AnimatePresence>

                  </li>

                );

              })}

            </ul>

          </div>

        </div>

      </Container>

    </Section>

  );
}